<template>
  <div class="row">
    <div class="col-12" v-if="filesLoaded">
      <b-card header="Uploaded FILES" header-tag="h4" body-class="mb-3 pb-0 record_card_body">
        <div class="row">
          <div v-if="files.length === 0" class="col-12">
            <h4 class="mb-3">There are currently no files uploaded for this worker</h4>
          </div>
          <div v-else class="col-12">
            <div class="row">
              <div class="col-12" v-if="check_if_id_file_uploaded">
                <h5 class="bp_color mb-3">IDENTITY FILES</h5>
              </div>
              <div class="col-12 files_uploaded" v-for="file in files" v-if="file.type.ident.startsWith('id_')">
                <div class="row">
                  <div class="col-lg-6">
                    <button @click="view_file_modal(file.id)" class="btn orcaBtn greenBtn sm_btn" data-toggle="tooltip" title="View Worker File"><i class="fas fa-eye"></i>&nbsp;
                      View
                    </button>
                    <span class="id_type">{{ file.type.file_type }}</span>
                  </div>
                  <div class="col-lg-6 pt-1">
                    <i>Uploaded By:</i> &nbsp;&nbsp;
                    <span v-if="file.file_log_by !== null && file.file_logs !== null && file.file_logs.log_by_type === 'App\\Models\\Users\\User'" class="note_user_created_at">
                      {{ file.file_log_by.first_name }} {{ file.file_log_by.surname }} - {{ file.updated_at | formatDateTime }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <hr>
              </div>
              <div class="col-12" v-if="check_if_not_id_file_uploaded">
                <h5 class="bp_color mb-3">OTHER FILES</h5>
              </div>
              <div class="col-12 files_uploaded" v-for="file in files" v-if="!file.type.ident.startsWith('id_')">
                <div class="row">
                  <div class="col-lg-6">
                    <button @click="view_file_modal(file.id)" class="btn orcaBtn greenBtn sm_btn" data-toggle="tooltip" title="View Worker File"><i class="fas fa-eye"></i>&nbsp;
                      View
                    </button>
                    <span class="id_type">{{ file.type.file_type }}</span>
                  </div>
                  <div class="col-lg-6 pt-1">
                    <i>Uploaded By:</i> &nbsp;&nbsp;
                    <span v-if="file.file_log_by !== null && file.file_logs !== null && file.file_logs.log_by_type === 'App\\Models\\Users\\User'" class="note_user_created_at">
                      {{ file.file_log_by.first_name }} {{ file.file_log_by.surname }} - {{ file.updated_at | formatDateTime }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-card>
    </div>
    <div class="col-12" v-else>
      <i class="fas fa-spinner fa-pulse"></i> &nbsp; Loading Files
    </div>
  </div>
</template>

<script>
export default {
  name: "files",
  props: ['files', 'filesLoaded'],
  methods: {
    check_if_id_file_uploaded() {
      let check_return = false;
      let check = this.files.filter(f => f.type.file_type.startsWith('id_'))
      if (check.length > 0) {
        check_return = true;
      }
      return check_return;
    },
    check_if_not_id_file_uploaded() {
      let check_return = false;
      let check = this.files.filter(f => !f.type.file_type.startsWith('id_'))
      if (check.length > 0) {
        check_return = true;
      }
      return check_return;
    },
    view_file_modal(file_id) {
      this.$store.commit('SHOW_VIEW_FILE_MODAL', {
        id: file_id,
        type: 'worker'
      });
      this.$store.state.files.view_modal = true;
      this.$nextTick(() => this.$root.$emit('bv::show::modal', 'view_file_modal'));
    },
  }
}
</script>

<style scoped lang="scss">
.files_uploaded {
  padding-left:  30px;
  margin-bottom: 15px;

  button {
    display:      inline-block;
    width:        auto;
    margin-right: 20px;
  }

  .id_type {
    font-weight: bold;
    display:     inline-block;
    width:       200px;
  }
}
</style>
